var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReturnGoodsCreationSection',{attrs:{"RG":_vm.RG,"optionsStorage":_vm.optionsStorage},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }